<h3 class="notification-title">{{notification.title}}</h3>
<p class="notification-message">{{notification.message}}</p>